import { Flame, MessageCircle, ClipboardList, Award } from "lucide-react";
import { AZIENDA } from "@/lib/config";

const MARCHI = [
  { id: "baxi", nome: "BAXI", logo: "/img/marchi/baxi.png" },
  { id: "immergas", nome: "IMMERGAS", logo: "/img/marchi/immergas.png" },
  { id: "bosch", nome: "BOSCH", logo: "/img/marchi/bosch.svg" },
];

const WA_TESTO = encodeURIComponent("Buongiorno, vorrei un preventivo per la sostituzione della caldaia.");

export const SostituzioneCaldaie = ({ onPreventivo }) => (
  <section id="caldaie" className="bg-white border-y border-slate-200" data-testid="caldaie-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24 grid lg:grid-cols-12 gap-10 items-center">
      <div className="lg:col-span-5">
        <p className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-orange-700"><Flame className="w-4 h-4" /> Sostituzione caldaia</p>
        <h2 className="mt-2 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">I migliori marchi al miglior prezzo sul mercato</h2>
        <p className="mt-4 text-slate-600">Sostituiamo la tua vecchia caldaia con un modello nuovo dei marchi di riferimento: BAXI, IMMERGAS e BOSCH. Installazione eseguita dai nostri tecnici con 30 anni di esperienza.</p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <button onClick={onPreventivo} className="inline-flex items-center justify-center gap-2 rounded-full bg-orange-600 text-white px-6 h-12 font-bold hover:bg-orange-700 transition-colors" data-testid="caldaie-preventivo-btn">
            <ClipboardList className="w-5 h-5" /> Richiedi preventivo
          </button>
          <a href={`${AZIENDA.whatsappLink}?text=${WA_TESTO}`} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 rounded-full bg-green-600 text-white px-6 h-12 font-bold hover:bg-green-700 transition-colors" data-testid="caldaie-whatsapp-btn">
            <MessageCircle className="w-5 h-5" /> Chiedi su WhatsApp
          </a>
        </div>
      </div>
      <div className="lg:col-span-7">
        <div className="grid grid-cols-3 gap-2 sm:gap-4">
          {MARCHI.map((m) => (
            <div key={m.id} className="group rounded-2xl border border-slate-200 bg-slate-50 p-2.5 sm:p-6 flex flex-col items-center gap-2 sm:gap-4 hover:border-sky-300 hover:-translate-y-1 hover:shadow-md transition-[transform,box-shadow,border-color] duration-200" data-testid={`marchio-card-${m.id}`}>
              <div className="h-16 sm:h-24 w-full grid place-items-center bg-white rounded-xl px-2 sm:px-5">
                <img src={m.logo} alt={`Logo ${m.nome}`} className="max-h-9 sm:max-h-14 max-w-full object-contain" data-testid={`marchio-logo-${m.id}`} />
              </div>
              <p className="flex items-center gap-1.5 text-[11px] sm:text-sm font-bold text-center"><Award className="hidden sm:block w-4 h-4 text-sky-600" /> Caldaie {m.nome}</p>
            </div>
          ))}
        </div>
        <p className="mt-4 text-xs text-slate-400">I marchi BAXI, IMMERGAS e BOSCH appartengono ai rispettivi proprietari.</p>
      </div>
    </div>
  </section>
);
